<template>
    <v-row class="dashboard-convention-filters">
        <v-col cols="5">
            <text-field v-model="filters.query" :solo="false" :hide-details="true" placeholder="Rechercher par mots clés dans mes favoris" clearable />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="3">
            <!--<my-select v-model="filters.order" />-->
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue';

import TextField from "src/components/common/form/TextField.vue";

    export default Vue.extend({
        props: ["filters"],
        model: {
            prop: "filters"
        },
        components: { TextField },
        watch: {
            "filters.order"() {
                this.$emit("input", { ...this.filters });
            },
            "filters.query"() {
                this.$emit("input", { ...this.filters });
            }
        }
    });
</script>

<style lang="sass" scoped>

    .dashboard-convention-filters
        display: flex
        position: relative
        background: $color-background
        // padding: 0 $grid-gutter $grid-gutter $grid-gutter
        // margin: $grid-gutter 0
        &:after
            position: absolute
            content: ""
            right: $grid-gutter/2
            left: $grid-gutter/2
            bottom: 7px
            // border-bottom: 1px solid $color-secondary

</style>